import {DataGridPageState, DispatchFilterFormValues, DispatchSeparatorMode, GridSort} from "@ots-frontend/ots-ui";
import {createAction} from "@reduxjs/toolkit";
import {DispatchDataGridPageState, DispatchDataGridView} from "./dispatch-page-store";

export const setDispatchPageFilter = createAction<DispatchFilterFormValues>("ui/dispatch-page/setFilter");
export const setDispatchPageState = createAction<DispatchDataGridPageState>("ui/dispatch-page/setState");
export const setDispatchPageStateCell = createAction<[col: number, row: number]>("ui/dispatch-page/setStateCell");
export const setDispatchPageStateWidths = createAction<(number | undefined)[]>("ui/dispatch-page/setStateWidths");
export const setDispatchPageStateSort = createAction<GridSort | undefined>("ui/dispatch-page/setStateSort");
export const setDispatchPageStateView = createAction<DispatchDataGridView>("ui/dispatch-page/setStateView");
export const setDispatchPageStateSeparatorMode = createAction<DispatchSeparatorMode>("ui/dispatch-page/setStateSeparatorMode");
